import { render, staticRenderFns } from "./GeofencingSettings.vue?vue&type=template&id=1c221fdf&scoped=true"
import script from "./GeofencingSettings.vue?vue&type=script&lang=js"
export * from "./GeofencingSettings.vue?vue&type=script&lang=js"
import style0 from "./GeofencingSettings.vue?vue&type=style&index=0&id=1c221fdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c221fdf",
  null
  
)

export default component.exports